import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("session exchange failed");
        const user = await res.json();
        navigate("/admin", { state: { user }, replace: true });
      } catch {
        navigate("/admin", { replace: true });
      }
    })();
  }, [location, navigate]);

  return (
    <div data-testid="auth-callback-loading" className="min-h-screen flex items-center justify-center bg-[#070709]">
      <p className="font-mono2 text-xs tracking-[0.3em] text-zinc-500 animate-pulse">SIGNING YOU IN…</p>
    </div>
  );
};
